import {Link} from "react-router-dom";

const Nav = () => {
    return (
        <ul className="mainmenu">
            <li className="has-droupdown"><Link to="/">Home</Link></li>
            <li><Link to="/about-us">About</Link></li>
            <li><Link to="/products">Products</Link></li>
            {/* Gallery hidden until images are updated */}
            {/* <li><Link to="/gallerys">Gallery</Link></li> */}
            <li><Link to="/career">Careers</Link></li>
            <li className="has-droupdown"><Link to="/contact">Contact</Link></li>
        </ul>
    )
}
export default Nav;
